//@ts-ignore
//@ts-nocheck
import {
  Fragment,
  FunctionComponent,
  memo,
  useCallback,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { DropzoneProps } from "./types";
import "./styles/styles.css";
import { StyledPDFIcon, StyledUploadFileIcon } from "./styles/DropZoneStyles";
const Dropzone: FunctionComponent<DropzoneProps> = ({
  previewUrl,
  onChange,
  value,
  id,
}) => {
  const [imageSrc, setImageSrc] = useState(previewUrl);
  const [selectedFileType, setSelectedFileType] = useState();

  const handleFileChange = (file) => {
    const reader = new FileReader();

    reader.onload = () => {
      // Determine if the file is an image or pdf before setting it as src
      if (file.type.startsWith("image/") || file.type === "application/pdf") {
        setImageSrc(reader.result);
        setSelectedFileType(file.type);
      } else {
        alert("Este archivo no es valido");
      }
    };

    reader.readAsDataURL(file);
  };

  const onDrop = useCallback((acceptedFiles) => {
    // Do something with the accepted files
    if (typeof onChange === "function") {
      onChange({
        target: {
          id: id,
          value: acceptedFiles,
        },
      });
      handleFileChange(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  return (
    <div className="border-2 h-64 border-gray-300 border-dashed rounded-lg p-4">
      <div
        {...getRootProps()}
        className={`text-center h-full justify-center flex flex-col ${
          isDragActive ? "bg-gray-100" : ""
        }`}
      >
        <input {...getInputProps()} multiple={false} />
        {imageSrc?.length > 0 ? (
          <div className="flex flex-col gap-4 items-center self-center">
            <Fragment>
              {selectedFileType === "application/pdf" ? (
                <StyledPDFIcon />
              ) : (
                <img src={imageSrc} className="w-32 h-32 object-contain" />
              )}
            </Fragment>

            <p className="text-lg">{value?.name}</p>
          </div>
        ) : (
          <StyledUploadFileIcon />
        )}

        {isDragActive ? (
          <p className="text-lg">Suelta los archivos aquí...</p>
        ) : (
          <Fragment>
            <p className="text-lg">
              Arrastra y suelta archivos aquí, o haz clic para seleccionar
              archivos
            </p>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default memo(Dropzone);
